import type { SubjectHistoryFeed } from "../../../../types";
import { useDeleteSubjectAction } from "../../api/useDeleteSubjectAction";

type Props = {
  item: SubjectHistoryFeed;
};

export function useDeleteSubjectActionModal(props: Props) {
  const { mutateAsync } = useDeleteSubjectAction();

  async function handleConfirm() {
    if (!props.item.id || !props.item.subject_id) return;
    await mutateAsync({ id: props.item.id, subTopicId: props.item.subject_id });
  }

  return { handleConfirm };
}
